export enum CurrencyEnum {
  Unknown = 0,
  PLN = 1,
  EUR = 2,
  USD = 3,
  GBP = 4,
  CHF = 5,
  JPY = 6
}

export type Currency = keyof typeof CurrencyEnum;

const CURRENCY_OPTION_ORDER: CurrencyEnum[] = [
  CurrencyEnum.USD,
  CurrencyEnum.EUR,
  CurrencyEnum.PLN,
  CurrencyEnum.GBP,
  CurrencyEnum.CHF,
  CurrencyEnum.JPY
];

export const CURRENCY_OPTIONS: { value: CurrencyEnum; label: Currency }[] = CURRENCY_OPTION_ORDER.map((value) => ({
  value,
  label: CurrencyEnum[value] as Currency
}));
